"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentStateValidation = void 0;
class PaymentStateValidation {
    static isValid(enumValue) {
        if (typeof enumValue !== "number")
            return false;
        if (!(0 <= enumValue && enumValue <= 10)) {
            return false;
        }
        return true;
    }
}
exports.PaymentStateValidation = PaymentStateValidation;
